// extracted by mini-css-extract-plugin
export default {"contact-section":"Contact_contact-section__26Hi7","black-overlay":"Contact_black-overlay__cltGo"};